const AUTH_HEADER = "X-Shopify-Access-Token";

const PARAMS = {
  status: "closed",
  fields: ["currency", "current_subtotal_price", "customer"],
};

// https://shopify.dev/api/admin-rest/2022-10/resources/order#resource-object

function orders() {
  return fetch(
    "/admin/api/2022-10/orders.json?" + new URLSearchParams(PARAMS),
    {
      headers: {
        Accept: "application/json",
        [AUTH_HEADER]: "AUTH_TOKEN",
      },
    }
  ).then((response) => response.json());
}

const BCK_API_URL = "https://gateway.backercamp.com/shopify-service-prod/";

function orderStatistics(shopName) {
  return fetch(
    BCK_API_URL + "order-statistics?" + new URLSearchParams({ shopName })
  ).then((response) => response.json());
}
